import $ from 'jquery'
import { setSameHeight, generateProductHTML, initSlides } from '../abstracts/utils'

export  default () => {
  $(() => {
    if (!$('body').hasClass('page-template-product_cat-listing')) return

    let $sectionSlideshow = $('.section-slideshow')
    initSlides($sectionSlideshow.find('.slideshow:not(.slick-initialized.slick-slider)'), 1, true, false, [], null, false)

    let $sectionProducts = $('.section-products')
    setSameHeight($sectionProducts.find('.products .product .product__content'))
    $(window).on('resize', function() {
      setSameHeight($sectionProducts.find('.products .product .product__content'))
    })
    // toggle filter on mobile
    $sectionProducts.find('.toggle-filter').on('click', function() {
      toggleFilter()
    })
    $sectionProducts.find('.filters .close').on('click', function() {
      toggleFilter()
    })

    $sectionProducts.find('input[name^="product-cat"').on('click', function() {
      if ($(this).is(':checked')) {
        $sectionProducts.find('input[name^="product-cat"]').not(this).prop('checked', false)
        $sectionProducts.find(`input[name^="product-cat"][value="${$(this).val()}"]`).not(this).prop('checked', true)
      } else {
        $sectionProducts.find(`input[name^="product-cat"][value="${$(this).val()}"]`).not(this).prop('checked', false)
      }
    })

    $sectionProducts.find('input[name^="product-brand"').on('click', function() {
      if ($(this).is(':checked')) {
        $sectionProducts.find(`input[name^="product-brand"][value="${$(this).val()}"]`).not(this).prop('checked', true)
      } else {
        $sectionProducts.find(`input[name^="product-brand"][value="${$(this).val()}"]`).not(this).prop('checked', false)
      }
    })

    // apply filter
    $sectionProducts.find('.apply-cta').on('click', function() {
      let chosenProductCatWords = []
      let chosenProductBrandWords = []

      if ($(this).hasClass('mobile')) {   // btn is clicked on mobile
        chosenProductCatWords = $sectionProducts.find('input[id^=mob-][name="product-cat[]"]:checked').toArray().map(item => {
          return {
            slug: $(item).val(),
            text: $(item).next('label').text()
          }
        })
        chosenProductBrandWords = $sectionProducts.find('input[id^=mob-][name="product-brand[]"]:checked').toArray().map(item => {
          return {
            slug: $(item).val(),
            text: $(item).next('label').text()
          }
        })
      } else {    // $(this).hasclass('desktop')
        chosenProductCatWords = $sectionProducts.find('input[id^=desk-][name="product-cat[]"]:checked').toArray().map(item => {
          return {
            slug: $(item).val(),
            text: $(item).next('label').text()
          }
        })
        chosenProductBrandWords = $sectionProducts.find('input[id^=desk-][name="product-brand[]"]:checked').toArray().map(item => {
          return {
            slug: $(item).val(),
            text: $(item).next('label').text()
          }
        })
      }

      $sectionProducts.find('.filtered-words').empty()

      filterProducts()

      for (let i = 0; i < chosenProductCatWords.length; i++)
        $sectionProducts.find('.filtered-words').append(generateFilteredWordHTML(chosenProductCatWords[i]))

      for (let i = 0; i < chosenProductBrandWords.length; i++)
        $sectionProducts.find('.filtered-words').append(generateFilteredWordHTML(chosenProductBrandWords[i]))

      setTimeout(() => {
        if ($(window).width() < 992) toggleFilter()

        $('html, body').animate({
          scrollTop: 0
        }, 500)
      }, 1000)
    })

    // clear filter
    $sectionProducts.find('.clear-cta').on('click', function() {
      $sectionProducts.find('input[name="product-cat[]"]:checked').toArray().map(item => {
        item.checked = false
      })
      $sectionProducts.find('input[name="product-brand[]"]:checked').toArray().map(item => {
        item.checked = false
      })
    })

    // filtered word
    $sectionProducts.find('.filtered-words').on('click', $sectionProducts.find('.filtered-words .filtered-word'), function(e) {
      let $word = $(e.target).closest('.filtered-word')
      $sectionProducts.find('input[value="' + $word.attr('slug') + '"]').prop('checked', false)
      $word.remove()

      filterProducts()
    })

    // load more
    $sectionProducts.find('.load-more-cta a').on('click', function(e) {
      let btn = $(e.target)
      let currentPage = parseInt(btn.attr('current-page'))
      let nextPage = currentPage + 1
      let chosenProductCats = btn.attr('product-cat').split(',')

      let chosenProductBrands = $sectionProducts.find('input[name="product-brand[]"]:checked').toArray().map(item => {
        return $(item).val()
      })

      $.get(window.endpoint + '/get-products-by-cat', {
        /* eslint-disable */
        'posts_per_page': localVar['posts_per_page'],
        'page': nextPage,
        'product_cat': chosenProductCats,
        'product_brand': chosenProductBrands
      })
        .done(res => {
          // console.log(res)
          if (res.products && res.products.length) {
            for (let i = 0; i < res.products.length; i++)
              $sectionProducts.find('.results .products').append(generateProductHTML(res.products[i]))
          }
          if (nextPage < res.max_num_pages) {
            btn.attr('current-page', nextPage)
          } else {
            btn.hide()
          }
          setSameHeight($('.section-products .products .product .product__content'))
        })
        .fail(err => {
          console.log(err)
        })
    })

  })
}

function filterProducts() {
  let chosenProductCatSlugs = $('.section-products input[name="product-cat[]"]:checked').toArray().map(item => {
    return $(item).val()
  })
  let chosenProductBrandSlugs = $('.section-products input[name="product-brand[]"]:checked').toArray().map(item => {
    return $(item).val()
  })

  let btn = $('.section-products .load-more-cta a')
  btn.attr('current-page', 1)
  btn.attr('product-cat', chosenProductCatSlugs.length ? chosenProductCatSlugs : localVar['root_product_cat'])

  $('.section-products .results .products').empty()

  $.get(window.endpoint + '/get-products-by-cat', {
    'posts_per_page': localVar['posts_per_page'],
    'product_cat': chosenProductCatSlugs.length ? chosenProductCatSlugs : [localVar['root_product_cat']],
    'product_brand': chosenProductBrandSlugs
  })
    .done(res => {
      // console.log(res)
      if (res.products && res.products.length) {
        for (let i = 0; i < res.products.length; i++)
          $('.section-products .results .products').append(generateProductHTML(res.products[i]))

        setSameHeight($('.section-products .products .product .product__content'))
      }
    })
    .fail(err => {
      console.log(err)
    })
    .always((data, textStatus, jqXHR) => {
      if (textStatus === 'success') {
        if (parseInt(btn.attr('current-page')) < data.max_num_pages) {
          btn.show()
        } else {
          btn.hide()
        }
      }
    })
}

function toggleFilter() {
  $('.filters.mobile').slideToggle().css('display', 'flex')
  $('.overlay').toggle()
}

function generateFilteredWordHTML(filteredWord) {
  let html = ''
  html += `<a class="filtered-word" slug="${filteredWord.slug}">${filteredWord.text}<span class="close icon-close"></span></a>`
  return html
}
